import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import iconFileDelete from "../../../assets/media/icon-file-delete.svg";
import iconSearch from "../../../assets/media/icon-search.svg";
import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
import iconCaretDown from "../../../assets/media/icon-caret-down.svg";
import Avatar01 from "../../../assets/media/avatar-01.png";
import iconRestore from "../../../assets/svgicons/restore.svg";
import iconMenuDots from "../../../assets/media/icon-menu-dots.svg";
import Navbar from "../../navbar";
import Header from "../../header";

import { useDispatch, useSelector } from "react-redux";
import {
  addEmployee,
  deleteEmployee,
} from "../../../store/reducers/employeeSlice.js";
import { fetchEmployee } from "../../../store/reducers/employeeSlice.js";
import Modal from "../../modal/Modal";
import classes from "./style.module.css";
import Pagination from "../dashboard/appPagination";
import userImagePlaceholder from "../../../assets/media/avatar2.jpg";
import { deleteUser, getallUser } from "../../../store/reducers/userSlice.js";
import ConfirmationModal from "../../common/confirmationModal.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

const AppEmployees = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchBy, setSearchBy] = useState("userId");
  const [currentPage, setCurrentPage] = useState(1);
  const user = useSelector((state) => state.auth.user);
  const employee = useSelector((state) => state.employee);
  const createLoading = useSelector((state) => state.employee.createLoading);
  const fetchLoading = useSelector((state) => state.employee.fetchLoading);
  const [selectedUser, setSelectedUser] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteComfirmModal, setShowDeleteComfirmModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredemployee, setFilteredEmplyee] = useState([]);
  const getallUserdata = useSelector((state) => state.userdata.getalluserdata);
  const [showDeleteEmpModal, setShowDeleteEmpModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [isRestore, setIsRestore] = useState(false);

  const navigate = useNavigate();

  const show = (item) => {
    console.log({ item });
    setModalContent(item);
    setShowModal(true);
  };
  const close = () => {
    setModalContent({});
    setShowModal(false);
  };

  const users = employee?.users;
  const authToken = user.access_token;

  const initialValues = {
    delete_message: "",
  };

  const validationSchema = Yup.object({
    delete_message: Yup.string(),
  });
  const [deleteLoader, setDeleteLoader] = useState(false);
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setDeleteLoader(true);
      setFieldValue("delete_message", "");
      dispatch(
        deleteEmployee({
          id: selectedUser.id,
          ...values,
          setShowDeleteComfirmModal,
          setDeleteLoader,
        })
      );
    },
  });

  const {
    values,
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    touched,
    setFieldError,
    setFieldValue,
  } = formik;
  const closeDeleteModal = () => {
    console.log({ errors });
    setFieldError("delete_message", "");
    setShowDeleteModal(false);
  };

  const filtered = (search = "") => {
    const finalArray = users?.filter((item) => {
      for (const key in item) {
        if (
          typeof item[key] === "string" &&
          item[key].toLowerCase().includes(search.toLowerCase())
        ) {
          return true;
        }
      }
      return false;
    });

    setData(finalArray);
    return finalArray;
  };

  const getTotalPages = () => {
    if (Number.isInteger(filteredemployee?.length / 10))
      return filteredemployee?.length / 10;
    return Math.floor(filteredemployee?.length / 10) + 1;
  };
  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleSearchByChange = (e) => {
    setSearchBy(e.target.value);
  };

  useEffect(() => {
    filtered();
  }, [users]);
  useEffect(() => {
    const performSearch = async () => {
      const dataSearch = await filtered(searchTerm);
      setData(dataSearch);
    };
    const debounceTimer = setTimeout(() => {
      performSearch();
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [searchTerm]);

  useEffect(() => {
    dispatch(fetchEmployee({ accessToken: authToken }));
    let queryParams = {
      page: currentPage,
      limit: 10,
    };

    if (searchQuery && searchQuery.trim() !== '') {
      queryParams[searchBy] = searchQuery.trim();
    }

    if (startDate) {
      queryParams.start_date = moment(startDate).format("YYYY-MM-DD");
    }
    if (endDate) {
      queryParams.end_date = moment(endDate).format("YYYY-MM-DD");
    }

    dispatch(
      getallUser({ authToken: user.access_token, queryParams: queryParams })
    );
  }, [authToken, dispatch, startDate, endDate, currentPage, searchQuery, searchBy]);

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setFilteredEmplyee(
      getallUserdata
        .filter((item) => {
          // Check common conditions first
          const isActive = item?.user_role !== "company_admin" && !item?.is_admin;
          if (!isActive) return false;

          // If no search query, return all active users
          if (!searchQuery) return true;

          const query = searchQuery.toLowerCase();

          // Strict filtering based on searchBy
          switch (searchBy) {
            case "userId":
              return item?.id?.toString().toLowerCase().includes(query);
            case "username":
              return item?.full_name?.toString().toLowerCase().includes(query);
            case "email":
              return item?.email?.toString().toLowerCase().includes(query);
            case "phone":
              return item?.phone?.toString().toLowerCase().includes(query);
            default:
              // Fallback to searching all fields if something goes wrong (optional)
              return Object.values(item).some(
                (value) =>
                  value &&
                  value.toString().toLowerCase().includes(query)
              );
          }
        })
        .sort((a, b) => b.id - a.id)
    );
  }, [getallUserdata, searchQuery, searchBy]);

  const paginatedEmployees = useMemo(() => {
    if (filteredemployee.length > 10) {
      const startIndex = (currentPage - 1) * 10;
      return filteredemployee.slice(startIndex, startIndex + 10);
    }
    return filteredemployee;
  }, [filteredemployee, currentPage]);

  const deleteuserdata = (id) => {
    const config = {
      accessToken: authToken,
      user_id: id,
    };
    dispatch(deleteUser({ configdata: config }));
    let queryParams = {};
    if (startDate && endDate) {
      queryParams.start_date = startDate.toISOString();
      queryParams.end_date = endDate.toISOString();
    }
    dispatch(
      getallUser({ authToken: user.access_token, queryParams: queryParams })
    );
  };

  // Define table columns
  const columns = useMemo(
    () => [
      {
        header: "S.NO.",
        cell: (info) => (currentPage - 1) * 10 + info.row.index + 1,
      },
      {
        header: "User Id",
        accessorKey: "id",
        cell: (info) => `GB-000000${info.getValue()}`,
      },
      {
        header: "Name",
        accessorKey: "full_name",
        cell: (info) => {
          const item = info.row.original;
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginRight: "20px" }}>
              <img
                src={item.image || userImagePlaceholder}
                alt="Avatar"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                }}
              />
              <div>
                <strong>{item.full_name}</strong>
                <span style={{ display: "block" }}>
                  {item.national_id_number || "--"}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        header: "Company",
        accessorKey: "company_name",
        cell: (info) => {
          const item = info.row.original;
          return (
            <span>{item.company?.company_name || "--"}</span>
          );
        },
      },
      // {
      //   id: "submitted_by",
      //   header: "Submitted By",
      //   cell: ({ row }) => {
      //     return (
      //       <div className="boardTitle">
      //         <strong>{row.companyName || row.company_name || 'N/A'}</strong>
      //         <span>{row.userEmail || row.email || 'N/A'}</span>
      //       </div>
      //     );
      //   }
      // },
      // {
      //   id: "submitted_for",
      //   header: "Submitted For",
      //   cell: (info) => {
      //     const row = info.row.original;
      //     return (
      //       <div className="boardTitle">
      //         <strong>{row.userName || row.user_name || 'N/A'}</strong>
      //         <span>{row.userEmail || row.user_email || row.email || 'N/A'}</span>
      //       </div>
      //     );
      //   },
      // },
      {
        header: "Email",
        accessorKey: "email",
        cell: (info) => (
          <span>{info.getValue()}</span>
        ),
      },
      {
        header: "Phone No.",
        accessorKey: "phone",
        cell: (info) => info.getValue(),
      },
      {
        header: "Create Date",
        accessorKey: "created_at",
        cell: (info) => info.getValue()?.slice(0, 10),
      },
      {
        header: "Status",
        accessorKey: "active",
        cell: (info) => (info.getValue() ? "Active" : "Inactive"),
      },
      {
        header: "Actions",
        cell: (info) => {
          const item = info.row.original;
          return (

            <div className="boardActions">
              <div className="dropdown d-inline-flex">
                <button
                  className="application-dropdown dropdown-toggle border-0 bg-transparent"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={iconMenuDots} alt="Menu Dots" />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li >
                    <Link className="dropdown-item" to={`/employees/${item.id}`}>View Details</Link>
                  </li>
                  <li>

                    <button
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation(); // Prevent row click
                        setShowDeleteEmpModal(true);
                        setDeleteUserId(item.id);
                        setIsRestore(item.is_deleted);
                      }}
                    >
                      {item.active ? "Delete" : "Restore"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      }
    ],
    [userImagePlaceholder, currentPage]
  );

  const table = useReactTable({
    data: paginatedEmployees,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <div>
        <Navbar />
        <Header />
        <div className="wrapper">
          <div className="boxAppBoard boxWhite">
            <div className="boardHeader noMg">
              <div className="boardHeadLeft">
                <h2>Registered Employees</h2>
              </div>
              <div className="boardHeadRight">

              </div>
            </div>
          </div>

          <div className="boxAppBoard boxWhite mt-5">
            <div
              style={{ flexWrap: "wrap", gap: "10px" }}
              className="boardHeader"
            >
              <div className="boardHeadLeft">
                <h2>All Employees</h2>
              </div>
              <div
                style={{
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                }}
                className="boardHeadRight"
              >
                <div className="">
                  <select onChange={handleSearchByChange} value={searchBy}>
                    <option value="userId">Search by ID</option>
                    <option value="username">Search by Name</option>
                    {/* <option value="email">Search by Email </option> */}
                    <option value="phone">Search by Phone </option>
                  </select>
                </div>
                <div className="searchForm">
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={handleSearchInputChange}
                    value={searchQuery}
                  />
                  <button>
                    <img src={iconSearch} alt="" />
                  </button>
                </div>
                <div className="datePicker">
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    isClearable={true}
                    placeholderText="Select Date Range"
                    className="date-range-input"
                    dateFormat="yyyy-MM-dd"
                  />
                </div>
              </div>
            </div>

            {/* New Table Implementation */}
            <div className="boardContent">
              {fetchLoading ? (
                <div className="d-flex justify-content-center my-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  {!!filteredemployee?.length ? (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                              {headerGroup.headers.map((header) => (
                                <th key={header.id}>
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody>
                          {table.getRowModel().rows.map((row) => (
                            <tr
                              key={row.id}

                            >
                              {row.getVisibleCells().map((cell) => (
                                <td key={cell.id}>
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <h2 className="text-danger my-4 py-4">
                        {fetchLoading ? "Loading..." : "Result not found"}
                      </h2>
                    </div>
                  )}
                </>
              )}
            </div>

            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={getTotalPages}
            />
          </div>
        </div>
        <ConfirmationModal
          show={showDeleteEmpModal && deleteUserId}
          title={`${isRestore ? "Restore" : "Delete"} Employee`}
          description={`Are you sure you want to ${isRestore ? "restore" : "delete"
            } this employee?`}
          handleClose={() => {
            setShowDeleteEmpModal(false);
            setDeleteUserId(null);
            setIsRestore(false);
          }}
          onConfirm={() => {
            deleteuserdata(deleteUserId);
            setShowDeleteEmpModal(false);
            setDeleteUserId(null);
            setIsRestore(false);
          }}
        />
      </div>
      {/* Rest of your modal code remains unchanged */}
      <Modal show={showModal} handleClose={close} colWidth={6}>
        {/* Modal content remains the same */}
      </Modal>
      <Modal show={showDeleteModal} colWidth={4}>
        {/* Delete modal content remains the same */}
      </Modal>
      <Modal
        show={showDeleteComfirmModal}
        colWidth={4}
        handleClose={() => {
          setShowDeleteModal(false);
          setShowDeleteComfirmModal(false);
          setFieldError("delete_message", "");
        }}
      >
        {/* Delete confirmation modal content remains the same */}
      </Modal>
    </>
  );
};
export default AppEmployees;